module.exports = __webpack_public_path__ + "static/media/island3r.246c78e2.svg";